<section class="luqta-card audit-card" aria-labelledby="audit-records-title">
  <header class="audit-head">
    <div class="audit-head__text">
      <h3 id="audit-records-title">
        {{ 'auditRecords.title' | translate }}
        <span class="audit-count" *ngIf="total > 0">{{ total }}</span>
      </h3>
      <p class="audit-sub">{{ 'auditRecords.subtitle' | translate }}</p>
    </div>
    <button type="button" class="audit-btn" (click)="export()" [disabled]="exporting || loading || total === 0"
      [attr.aria-busy]="exporting">
      <i class="fa-solid" [ngClass]="exporting ? 'fa-spinner fa-spin' : 'fa-file-arrow-down'" aria-hidden="true"></i>
      {{ (exporting ? 'auditRecords.exporting' : 'auditRecords.export') | translate }}
    </button>
  </header>

  <p class="audit-note" *ngIf="!ledger && !loadFailed" role="note">
    <i class="fa-solid fa-circle-info" aria-hidden="true"></i>
    {{ 'auditRecords.ledgerPending' | translate }}
  </p>

  <div class="audit-error" *ngIf="loadFailed" role="alert">
    <span>{{ 'auditRecords.loadFailed' | translate }}</span>
    <button type="button" class="audit-btn audit-btn--ghost" (click)="load(page)">{{ 'auditRecords.retry' | translate }}</button>
  </div>

  <nz-table *ngIf="!loadFailed" #auditTable [nzData]="records" [nzBordered]="true" [nzLoading]="loading"
    [nzFrontPagination]="false" [nzTotal]="total" [nzPageIndex]="page" [nzPageSize]="perPage"
    [nzShowPagination]="total > perPage" (nzPageIndexChange)="load($event)" [nzScroll]="{ x: '1080px' }"
    [nzNoResult]="emptyState">
    <thead>
      <tr>
        <th nzWidth="48px"><span class="visually-hidden">{{ 'auditRecords.details' | translate }}</span></th>
        <th nzWidth="200px">{{ 'auditRecords.col.participant' | translate }}</th>
        <th nzWidth="180px">{{ 'auditRecords.col.level' | translate }}</th>
        <th nzWidth="80px">{{ 'auditRecords.col.attempt' | translate }}</th>
        <th nzWidth="200px">{{ 'auditRecords.col.outcome' | translate }}</th>
        <th nzWidth="170px">{{ 'auditRecords.col.verifiedBy' | translate }}</th>
        <th nzWidth="100px">{{ 'auditRecords.col.confidence' | translate }}</th>
        <th nzWidth="150px">{{ 'auditRecords.col.submitted' | translate }}</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let record of auditTable.data; trackBy: trackRecord">
        <tr>
          <td [nzExpand]="expanded.has(record.attempt_id)" (nzExpandChange)="toggle(record, $event)"
            [attr.aria-label]="'auditRecords.details' | translate"></td>
          <td>
            <div class="audit-who">
              <span class="audit-who__name">{{ record.participant_name || ('auditRecords.unnamed' | translate) }}</span>
              <span class="audit-flag" *ngIf="record.flagged" nz-tooltip [nzTooltipTitle]="'auditRecords.flaggedHint' | translate">
                <i class="fa-solid fa-flag" aria-hidden="true"></i>{{ 'auditRecords.flagged' | translate }}
              </span>
            </div>
            <span class="audit-phone" dir="ltr" *ngIf="record.phone_number">{{ record.phone_number }}</span>
          </td>
          <td>
            <span class="audit-level">{{ levelName(record) }}</span>
            <span class="audit-muted">{{ record.level_type }}</span>
          </td>
          <td class="audit-num">{{ record.attempt_no ?? '—' }}</td>
          <td>
            <span class="audit-pill" [ngClass]="statusTone(record.status)">{{ statusLabel(record.status) }}</span>
            <span class="audit-reason" *ngIf="record.reason || record.reason_code">{{ record.reason || record.reason_code }}</span>
          </td>
          <td>
            <span>{{ methodLabel(record.verification_method) }}</span>
            <span class="audit-muted">{{ sourceLabel(record.source) }}</span>
          </td>
          <td class="audit-num">
            <span [nzTooltipTitle]="record.confidence_formula ? (('auditRecords.formula' | translate) + ': ' + record.confidence_formula) : null" nz-tooltip>
              {{ confidenceText(record.confidence) }}
            </span>
          </td>
          <td>{{ (record.submitted_at || record.started_at) ? ((record.submitted_at || record.started_at) | date: 'medium') : '—' }}</td>
        </tr>
        <tr [nzExpand]="expanded.has(record.attempt_id)">
          <div class="audit-detail">
            <div class="audit-detail__block">
              <h4>{{ 'auditRecords.answers' | translate }}</h4>
              <p class="audit-muted" *ngIf="record.answers_withheld">{{ withheldLabel(record.answers_withheld) }}</p>
              <ul *ngIf="!record.answers_withheld && answerLines(record).length; else noAnswers">
                <li *ngFor="let line of answerLines(record)">{{ line }}</li>
              </ul>
              <ng-template #noAnswers>
                <p class="audit-muted" *ngIf="!record.answers_withheld">{{ 'auditRecords.noAnswers' | translate }}</p>
              </ng-template>
            </div>
            <div class="audit-detail__block">
              <h4>{{ 'auditRecords.proof' | translate }}</h4>
              <dl *ngIf="proofEntries(record).length; else noProof">
                <ng-container *ngFor="let entry of proofEntries(record)">
                  <dt>{{ entry.key }}</dt>
                  <dd dir="auto">{{ entry.value }}</dd>
                </ng-container>
              </dl>
              <ng-template #noProof><p class="audit-muted">{{ 'auditRecords.noProof' | translate }}</p></ng-template>
              <p class="audit-muted" *ngIf="record.verified_at">
                {{ 'auditRecords.verifiedAt' | translate }}: {{ record.verified_at | date: 'medium' }}
              </p>
            </div>
          </div>
        </tr>
      </ng-container>
    </tbody>
  </nz-table>

  <ng-template #emptyState>
    <div class="audit-empty">
      <i class="fa-regular fa-rectangle-list" aria-hidden="true"></i>
      <p>{{ 'auditRecords.empty' | translate }}</p>
    </div>
  </ng-template>
</section>
